// extracted by mini-css-extract-plugin
module.exports = {"arrow_icon":"ArrowIcon_arrow_icon__zQZS0","up":"ArrowIcon_up__vVeBM","down":"ArrowIcon_down__DKW2r"};